import React, {useEffect, useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import {connect} from "react-redux";
import Grid from "@material-ui/core/Grid";
import InfoCard from "../StudyRequestInfo/InfoCard";
import AccessTimeOutlinedIcon from "@material-ui/icons/AccessTimeOutlined";
import StateInfoField from "../StudyRequestInfo/StateInfoField";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import {getRequestGroupCard, getRequestProgramCard} from "../../../store/actions";
import {setRequestGroup, setRequestProgram} from "../../../store/send";
import {format, parseISO} from "date-fns";
import ru from "date-fns/locale/ru";
import SelectGroupModal from "../StudyRequestInfo/SelectGroupModal";
import Progress from "../../../../../ui/Progress";
import IconButton from "@material-ui/core/IconButton";
import LinkOffIcon from "@material-ui/icons/LinkOff";
import SelectProgramModal from "../../../components/SelectProgramModal";

const useStyles = makeStyles(() => ({
  root: {
    paddingLeft: 8,
    width: 774,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  progress: {
    display: "flex",
    justifyContent: "center"
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  block: {
    margin: "0 0 32px 0"
  }
}));

const formatDate = date =>
  date ? format(parseISO(date), "dd.MM.yyyy", { locale: ru }) : null;


const formatWeekDays = days =>
  days.replace('MO', 'пн').replace('TU','вт').replace('WE','ср').replace('TH','чт').replace('FR','пт').replace('SU','сб');

const Programs = ({
                    requestId,
                    requestProgramName,
                    requestProgramTargetGroup,
                    status, programId,
                    getRequestGroupCard, requestGroup,
                    getRequestProgramCard, requestProgram,
                    setRequestProgram,
                    setRequestGroup,
                    isFetchingWorkProcess
                          }) => {
  const classes = useStyles();
  const [groupsModalOpen, setGroupsModalOpen] = useState(false);

  useEffect(() => {
    if (requestId) {
      getRequestGroupCard(requestId);
      getRequestProgramCard(requestId);
    }
  }, [requestId]);

  const cardActions = [
    {
      label: "ВЫБРАТЬ ГРУППУ",
      disabled: false,
      onClick: () => { setGroupsModalOpen(true) }
    }
  ];


  return (
    <div className={classes.root}>
       {requestProgram &&
        <SelectGroupModal requestId={requestId}
                          programId={requestProgram.id}
                          open={groupsModalOpen}
                          handleAccept={setRequestGroup}
                          handleClose={() => setGroupsModalOpen(false)}/>}

      <div className={classes.block}>
        <Typography className={classes.heading}>Выбранная программа обучения</Typography>

        <Grid container spacing={1} justify="flex-start" alignItems="flex-start">
          <Grid item xs={12} sm={6}>
            <InfoCard title="Программа обучения"
                      icon={<AccessTimeOutlinedIcon/>}
                      contentTitle={requestProgram ? requestProgram.name : "не выбрана"}
                      linkTo={requestProgram && requestProgram.id ? `/work/app/manage/resources/programs/myprograms/${requestProgram.id}` : null}
                      subheader={requestProgram && requestProgram.id ? "привязана" : "отсутствует"}
                      loading={isFetchingWorkProcess}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InfoCard title="Учебная группа"
                      icon={<PeopleAltOutlinedIcon/>}
                      contentTitle={requestGroup ? `Группа ${requestGroup.code}` : "не выбрана"}
                      linkTo={requestGroup ? `/work/app/study/groups/${requestGroup.id}` : null}
                      subheader={requestGroup && requestGroup.id ? "привязан" : "отсутствует"}
                      contentBody={requestGroup ? <>
                        <StateInfoField field="Вид группы" value={requestGroup.groupType === 1 ? 'Коммерческая' : (requestGroup.groupType === 2 ? 'Бесплатная' : 'Смешанная')}/>
                        <StateInfoField field="Старт группы" value={requestGroup.startDate ? formatDate(requestGroup.startDate) : '-'}/>
                        <StateInfoField field="Начало занятий" value={requestGroup.startTime || '-'}/>
                        <StateInfoField field="Окончание занятий" value={requestGroup.endTime || '-'}/>
                        <StateInfoField field="Дни недели" value={requestGroup.recurrenceDays ? formatWeekDays(requestGroup.recurrenceDays) : '-'}/>
                      </> : <></>}
                      loading={isFetchingWorkProcess}
                      action={(status === 1 && requestGroup) &&
                      <IconButton onClick={() =>  setRequestGroup(requestId, -1) } title="Удалить связь">
                        <LinkOffIcon/>
                      </IconButton>}
                      cardActions={status === 1 ? cardActions : null}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  requestGroup: state.studyRequests.requestGroup,
  requestProgram: state.studyRequests.requestProgram
});

const mapDispatchToProps = dispatch => ({
  getRequestGroupCard: (id) => dispatch(getRequestGroupCard(id)),
  getRequestProgramCard: (id) => dispatch(getRequestProgramCard(id)),
  setRequestProgram: (id, programId) => dispatch(setRequestProgram(id, programId)),
  setRequestGroup: (id, groupId, newGroupData) => dispatch(setRequestGroup(id, groupId, newGroupData)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Programs);
